import { render, staticRenderFns } from "./KvCitySelect.vue?vue&type=template&id=70825bd0&scoped=true&"
import script from "./KvCitySelect.vue?vue&type=script&lang=js&"
export * from "./KvCitySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70825bd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70825bd0')) {
      api.createRecord('70825bd0', component.options)
    } else {
      api.reload('70825bd0', component.options)
    }
    module.hot.accept("./KvCitySelect.vue?vue&type=template&id=70825bd0&scoped=true&", function () {
      api.rerender('70825bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/KvCitySelect.vue"
export default component.exports